import { render, staticRenderFns } from "./DictDeleteList.vue?vue&type=template&id=6509de05&scoped=true"
import script from "./DictDeleteList.vue?vue&type=script&lang=js"
export * from "./DictDeleteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6509de05",
  null
  
)

export default component.exports